import React, { useState } from 'react';
import { icons } from 'utils/constants';
import './FollowUpAndDiscount.scss';
import { useNavigate } from 'react-router-dom';

const FollowUpAndDiscountCard = ({ logo, title, date, location, event_id }) => {
  const navigate = useNavigate();
  return (
    <div id="followup-card-container">
      <div className="followupCard ">
        <div className="card-img">
          <img src={logo} alt="Event Logo" />
        </div>

        <div className="cps-16 cpe-44 cpb-27 cpt-16">
          <p
            className={`text-14-400-24 text-dots-conference-segment`}
            onClick={() => {
              navigate(`/admin/follow-up-discount/${event_id}`);
              // setExistsFollowup()
            }}
          >
            {title}
          </p>

          <div className="d-flex align-items-center text-14-300-18 ">
            <img src={icons.locationEvent} className="w-16 h-16 cme-8" />{' '}
            {location}
          </div>

          <div className="d-flex align-items-center text-14-300-18 cmt-16">
            <img src={icons.calendarEvent} className="w-16 h-16 cme-8" />
            {date}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowUpAndDiscountCard;
